(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wc-language-preference"] && !Shopify.designMode) return;
  try {
    (() => {
    const context = document.getElementById('wc-language-preference');
    if (!context) return;

    const form = context.querySelector('form');
    const input = form.elements.namedItem('language_code');
    const available = Array.from(input.options, (option) => option.value);
    const current = context.dataset.language;
    const preferenceKey = `wc:language:${context.dataset.theme}`;
    const attemptKey = `${preferenceKey}:attempt`;
    const returnTo = (targetForm) => {
      const field = targetForm.elements.namedItem('return_to');
      if (field) field.value = window.location.pathname + window.location.search + window.location.hash;
    };
    const remember = (language) => {
      if (!available.includes(language)) return;
      try {
        localStorage.setItem(preferenceKey, language);
        sessionStorage.removeItem(attemptKey);
      } catch {}
    };

    document.addEventListener('change', (event) => {
      const target = event.target;
      if (target instanceof HTMLSelectElement && target.name === 'language_code' && target.form) {
        remember(target.value);
        returnTo(target.form);
      }
    }, true);

    document.addEventListener('submit', (event) => {
      const button = event.submitter;
      if (button?.name === 'language_code') {
        remember(button.value);
        returnTo(event.target);
      }
    }, true);

    if (context.dataset.designMode === 'true' || window.Shopify?.designMode || window.self !== window.top) return;

    try {
      const saved = localStorage.getItem(preferenceKey);
      const explicitPath = context.dataset.root !== '/';
      const parameters = new URLSearchParams(window.location.search);
      const explicitQuery = parameters.has('locale') || parameters.has('language');
      if (explicitPath || explicitQuery) {
        if (!available.includes(saved)) localStorage.setItem(preferenceKey, current);
        if (sessionStorage.getItem(attemptKey) === current) sessionStorage.removeItem(attemptKey);
        return;
      }

      const browserLanguages = navigator.languages?.length ? navigator.languages : [navigator.language];
      const browserChoice = browserLanguages
        .map((language) => (language || '').toLowerCase().split('-')[0])
        .find((language) => ['en', 'ar'].includes(language) && available.includes(language));
      const target = available.includes(saved) ? saved : browserChoice || (available.includes('en') ? 'en' : current);
      localStorage.setItem(preferenceKey, target);
      if (target === current) {
        sessionStorage.removeItem(attemptKey);
        return;
      }
      if (sessionStorage.getItem(attemptKey) === target) return;
      sessionStorage.setItem(attemptKey, target);
      if (sessionStorage.getItem(attemptKey) !== target || localStorage.getItem(preferenceKey) !== target) return;
      input.value = target;
      returnTo(form);
      form.submit();
    } catch {}
  })();
  } catch(e) { console.error(e); }
})();

})();
